var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 315,
    viewBox: "0 0 353 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177 276H152.5L126.5 271L124.5 272.5L22 306L57.5 238.5L42 225L32.5 213.5L22 197.5L11.5 175.5L6 150L8 124L14.5 102.5L25.5 80L40 61.5L63 41L81 29L117 14L145.5 8.5L178.5 6L210.5 8.5L244 17L273 29L294 43L316.5 63.5L331.5 84L342 108L347.5 135L345.5 163L339 183.5L324 209.5L305.5 230L284 247.5L263.5 258L239 267.5L211 272.5L177 276Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.39d51000eef117c8e632fb342c42d733.svg";
export { ForwardRef as ReactComponent };